<template>
  <div class="download2">
    <div class="header-img">
      <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download/banner.png" alt />
    </div>
    <div class="toobar">
      <img align="Baseline" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download2/shouye.png" />&nbsp;&nbsp;&nbsp;1+X证书&nbsp;&nbsp;&nbsp;
      <img align="AbsMiddle" src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download2/sanjiao.png" />&nbsp;&nbsp;&nbsp;循环流化床锅炉学习资料
    </div>
    <div class="middle">
      <div class="wenzi" style="margin: 0px auto;width: 1100px;">
        <div style="font-size: 24px;color: black;padding: 100px 0;">
         <!-- <p><a href="http://bernouly.oss-cn-beijing.aliyuncs.com/materials/220T循环流化床锅炉机组仿真机启动操作指南.pdf" target="_blank">220T循环流化床锅炉机组仿真机启动操作指南.pdf</a></p>
		  <br><p><a href="http://bernouly.oss-cn-beijing.aliyuncs.com/materials/220T循环流化床锅炉说明书.pdf" target="_blank">220T循环流化床锅炉说明书.pdf</a></p>
		  <br><p><a href="http://bernouly.oss-cn-beijing.aliyuncs.com/materials/220T循环流化床锅炉系统图.pdf" target="_blank">220T循环流化床锅炉系统图.pdf</a></p>
		  <br><p><a href="http://bernouly.oss-cn-beijing.aliyuncs.com/materials/220T循环流化床锅炉运行规程.pdf" target="_blank">220T循环流化床锅炉运行规程.pdf</a></p>
		  -->
		  <div class="download-list">
		      <div class="download-list-title">
		          <div>名称</div>
		          <div>大小</div>
		          <div>操作</div>
		      </div>
		      <div class="download-list-list">
		          <div>220T循环流化床锅炉机组仿真机启动操作指南</div>
		          <div>3.01MB</div>
		          <div><p><a href="/assets/materials/220T循环流化床锅炉机组仿真机启动操作指南.pdf"  target="_blank">查看</a></p></div>
		      </div>
		      <div class="download-list-list">
		          <div>220T循环流化床锅炉说明书</div>
		          <div>0.75MB</div>
		          <div><p><a href="/assets/materials/220T循环流化床锅炉说明书.pdf" target="_blank">查看</a></p></div>
		      </div>
		      <div class="download-list-list">
		          <div>220T循环流化床锅炉系统图</div>
		          <div>2.50MB</div>
		          <div><p><a href="/assets/materials/220T循环流化床锅炉系统图.pdf" target="_blank">查看</a></p></div>
		      </div>
		      <div class="download-list-list">
		          <div>220T循环流化床锅炉运行规程</div>
		          <div>2.80MB</div>
		          <div><p><a href="/assets/materials/220T循环流化床锅炉运行规程.pdf" target="_blank">查看</a></p></div>
		      </div>
		  </div>
        </div>
		
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style scoped>
.download2 {
  background: #eee;
}

.download2 img {
    display: inline-block;
}

.download2 .header-img {
  width: 100%;
  height: 237px;
}

.download2 .header-img img {
  width: 100%;
  height: 100%;
}

.download2 .middle {
  width: 100%;
  /* height: 680px; */
  background-color: white;
  background-size: 100% 100%;
}

.download2 .toobar {
  height: 90px;
  width: 1100px;
  margin: 0 auto;
  line-height: 90px;
  color: #929292;
  font-size: 16px;
}

.download2 .middle img:hover {
  cursor: pointer;
}

.download2 a {
  text-decoration: none;
}

a:link{
	color: black;
}

.download2 a:hover {
  cursor: pointer;
  color: #0055D3;
}

.download2 li {
  width: 100px;
  height: 80px;
  color: #fefefe;
  line-height: 80px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  display: list-item;
}

.download2 li:hover {
  background: #0a57f4;
}

.download-list {
    width: 1200px;
    margin: 0 auto;
}
.download-list-title {
    height: 50px;
    display: flex;
    line-height: 50px;
}
.download-list-title div {
    background: #0055d3;
    color: #fff;
    padding-left: 20px;
    font-size: 16px;
}
.download-list-title div:nth-child(1) {
    width: 672px;
    margin-right: 2px;
}
.download-list-title div:nth-child(2) {
    width: 231px;
    margin-right: 2px;
}
.download-list-title div:nth-child(3) {
    width: 231px;
}
.download-list-list {
    height: 70px;
    display: flex;
    line-height: 70px;
    color: #333;
    font-size: 16px;
}
.download-list-list:nth-child(2n + 1) {
    background: #eee;
}
.download-list-list div {
    padding-left: 20px;
}
.download-list-list div:nth-child(1) {
    width: 672px;
    margin-right: 2px;
}
.download-list-list div:nth-child(2) {
    width: 231px;
    margin-right: 2px;
}
.download-list-list div:nth-child(3) {
    width: 231px;
    display: flex;
    align-items: center;
}
.download-list-list div:nth-child(3) p {
    width: 136px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 2px solid #0055d3;
    border-radius: 30px;
    background: #fff;
    cursor: pointer;
}
.download-list-list div:nth-child(3) p a {
    color: #0055d3;
}
.download-list-list div:nth-child(3) p:hover a {
    color: #fff;
}
.download-list-list div:nth-child(3) p:hover {
    background: #0055d3;
}
</style>